import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';

import { VStack } from '../../../../../../../Stack';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloatingDrawerNavLinksList = (props: Props) => {
  const { children, hasDivider = false } = props;

  // ─── Styles ────────────────────────────────────────────────────────────────

  const containerStyles = hasDivider && styles.containerWithDivider;

  return (
    <VStack gap={theme.spacing['2']} style={containerStyles}>
      {children}
    </VStack>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerWithDivider: {
    paddingTop: theme.spacing['6'],
    borderTopWidth: 1,
    borderTopColor: theme.colors.LIGHT,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  hasDivider?: boolean;
}>;
